import React from "react";
import "../App.scss";

class QuickSearchBox extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
    this.onNewEvent = this.onNewEvent.bind(this);
  }

  onNewEvent = (searchText: any) => {
    if (!searchText || searchText === "") {
      this.props.onSearch(this.props.items);
      return;
    }

    const filtered =
      this.props.items?.filter((it: any) =>
        Object.values(it)
          .join(";")
          .toLocaleLowerCase("tr")
          .includes(searchText.toLocaleLowerCase("tr"))
      ) || [];

    this.props.onSearch(filtered);
  };

  render() {
    const { ...rest } = this.props;

    return (
      <div className="search-container">
        <input
          type="text"
          placeholder="Ara..."
          onChange={(e) => this.onNewEvent(e.target.value)}
          className="search-input"
        />
        <div className="search-icon"></div>
      </div>
    );
  }
}

export default QuickSearchBox;
